/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_StepsInputs */

const en_cook_done_steps = /** @type {(inputs: Cook_Done_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the steps`)
};

const de_cook_done_steps = /** @type {(inputs: Cook_Done_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Schritten`)
};

/**
* | output |
* | --- |
* | "Back to the steps" |
*
* @param {Cook_Done_StepsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_steps = /** @type {((inputs?: Cook_Done_StepsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_StepsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_steps(inputs)
	return en_cook_done_steps(inputs)
});